module.exports = __webpack_public_path__ + "img/1544304018.1b8d675a.jpg";